<template>
	<div class="flsm">
		<div class="banimg">
			<div class="txt">
				<div class="w1200">
					{{$t('xwzx')}}
					<p>not just a customer, but partners</p>
				</div>
			</div>
			<img src="../../assets/img/bg_news.jpg" alt="">
		</div>
		<div class="mbxs">
			<div class="w1100">
				<router-link to='/about'>{{$t('gsjj')}}</router-link>
				<router-link to='/gszl'>{{$t('gszl')}}</router-link>
				<!-- <router-link class="on" to='/news'>{{$t('xwzx')}}</router-link> -->
			</div>
		</div>
        <div class="mbx">
			<div class="flex1 hsbg"></div>
			<div class="w1100">
				<div>
					<router-link to='/'>{{$t('home')}}</router-link>
					<router-link to='/about'>-{{$t('gyKoreSemi')}}</router-link>
                    <!-- <router-link to='/news'>-{{$t('xwzx')}}</router-link> -->
					<router-link to='/category-list'>-{{$t('video')}}</router-link>
					<span>-{{$t('videozxlb2')}}</span>
				</div>
			</div>
			<div class="flex1"></div>
		</div>
        <div class="news-list w1100">
            <div class="video-list">
                <div class="video-item" v-for="(item,index) in videoList" :key="index">
                    <viewer :images="item.pics" v-if="item.video==undefined||item.video==''"> 
                     <img class="img" v-for="(src,index) in item.pics" :src="src" :key="index" v-show="index==0"><!--:onerror="errorImg" -->
                    </viewer>
                    <video-player  @play="onPlayerPlay(index)" v-if="item.video!=undefined&&item.video!=''" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="item.playerOptions" ></video-player>
                    <div class="text">{{item.title}}</div>
                </div>
            </div>
        </div>
        <div class="pages">
            <x-pagination @on-change='change' @on-prev='change' @on-next='change' :totalPage='totalPage' :currentPage="page+1" v-if="totalPage>=1"></x-pagination>
        </div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				zl:false,
				zl1:false,
				xwlist:[],
                categoryId:null,
				page:0,
				totalPage:1,
                videoList:[],
                playerOptions: {
            		playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
            		autoplay: false, // 如果为true,浏览器准备好时开始回放。
            		muted: false, // 默认情况下将会消除任何音频。
            		loop: false, // 是否视频一结束就重新开始。
            		preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            		language: 'zh-CN',
            		aspectRatio: '21:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            		fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
            		sources: [
						{type: "video/mp4", // 类型
           			 }],
            		poster: null, // 封面地址
            		notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
            		controlBar: {
              			timeDivider: false, // 当前时间和持续时间的分隔符
              			durationDisplay: false, // 显示持续时间
              			remainingTimeDisplay: false, // 是否显示剩余时间功能
              			fullscreenToggle: true // 是否显示全屏按钮
            		}
          		},
			}
		},
		created() {
            this.categoryId = this.$route.query.id;
			var that=this;
			that.page=0;
			that.pages();
		},
		methods:{
			change(e){
				// console.log(e)
				var that=this
				that.page=e-1
				that.pages()
			},
			pages(){
                let row = 12;
				var that=this;
                let url = process.env.VUE_APP_SERVICE_URL+"/api/news/listByCategoryVideo?page="+this.page+'&row='+row+"&category="+this.categoryId;
				that.$ajax({
					method: 'get',
					url: url,
					headers: {
						'Accept': '*/*',
						'Content-Type': 'application/json, text/plain, */*'
					},
				
				}).then(function(res) {
					that.videoList=res.data.records;
                    let pics = null;
                    //判断是单图还是多图
                    for(let i=0;i<that.videoList.length;i++){
                        if(that.videoList[i].image.indexOf(",")>-1){
                            pics = that.videoList[i].image.split(",");
                            that.videoList[i].pic = pics[0];
                            that.videoList[i].pics = pics;
                        }else{
                            that.videoList[i].pic = that.videoList[i].image;
                            that.videoList[i].pics = [];
                            that.videoList[i].pics.push(that.videoList[i].pic);
                        }
                        if(that.videoList[i].video!=undefined&&that.videoList[i].video!=''){
                            that.videoList[i].playerOptions = JSON.parse(JSON.stringify(that.playerOptions));
                            that.videoList[i].playerOptions.poster =  that.videoList[i].pic;
                            that.videoList[i].playerOptions.sources[0].src = that.videoList[i].video;
                        }
                    }

					that.totalPage=Math.ceil(res.data.total / row);
					// console.log(Math.ceil(44 / 10), 44 / 10)
				})
			},
			nato(id){
				var that=this
				// that.$router.push('/slzj/lists/' + e)
				that.$router.push('/details?id='+id)
			},
            onPlayerPlay(key){
                let index = -1;
                for(let i=0;i<this.videoList.length;i++){
                    if(this.videoList[i].video!=undefined&&this.videoList[i].video!=""){
                        index++;
                        if(key==i){
                            break;
                        }
                    }
                }   

                for(let j=0;j<this.$refs.videoPlayer.length;j++){
                    if(j!=index){
                        this.$refs.videoPlayer[j].player.pause();
                    }
                }
            }
		}
	}
</script>

<style lang="scss" scoped>
.flsm{
    // .mbxs{
    //     margin-bottom: 50px;
    // }
    .mbx{
         margin-bottom: 20px;
    }
    .news-list{
        padding-bottom: 50px;
        .news-title{
            font-size: 24px;
            color: #333333;
            font-weight: bold;
            width: 65px;
            border-bottom: #4198CC 6px solid;
            margin: 0 auto;
            text-align: center;
            margin-bottom: 59px;
        }
        .more-new-wrap{
            display: flex;
            justify-content: flex-end;
            margin-top: 23px;
            .more-new{
                display: flex;
                justify-content: flex-end;
                align-items: center;
                cursor: pointer;
                width:90px;
                .label{
                    color: #666666;
                    font-size: 15px;
                    margin-right: 6px;
                }
                .arrow {
                    width:17px;
                    height: 15px;
                    background: url("../../assets/img/arrowRightGrey.png") center center no-repeat;
                    background-size: contain;
                }
                &:hover{
                    .label{
                       color: #333333;
                    }
                    .arrow{
                        background: url("../../assets/img/arrowRightBlue.png") center center no-repeat;
                        background-size: contain;
                    }
                }
            }
        }
        .video-list{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;

            .video-item{
                width: 333px;
                height: 279px;
                background: #fff;
                padding:20px;
                box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
                border-radius: 5px;
                margin-left: 15px;
                margin-right: 15px;
                cursor: pointer;
                margin-bottom: 20px;
                &:hover{
                    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
                    .text{
                        color:#4198CC
                    }
                }
                .img{
                    background: #999;
                    height: 170px;
                    margin-bottom: 20px;
                    width: 100%;
                    height: 170px;
                    object-fit: cover;
                }
                .text{
                    height: calc(100% - 190px);
                    color: #191919;
                    font-size: 16px;
                    line-height: 25px;
                    font-weight: bold;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
        }   
    }
}
</style>

<style lang="scss">
.video-player {
    margin-bottom:20px;
}
.video-js  {
    height: 170px!important;
}
</style>
